/**
 * Represents a collection of common text used in the application.
 */
export const Vocabulary: any = {
  /** COMMON TEXT */
  login: "Conectare",
  privacyPolicyTitle:
    "Politica de confidențialitate — Portal Sigur La Volan și Extensia de browser",
  privacyPolicyLastUpdated: "Ultima actualizare: 28.09.2026",
  loginValidationError: "Eroare la validarea datelor!",
  formValidationError: "Formularul conține câmpuri completate greșit. Vă rugăm verificați datele introduse.",
  requiredField: "Acest câmp este obligatoriu.",
  emailValidation: "Introduceți  o adresă valida.",
  pastDateNotAllowed: "Nu puteți programa ședințe în trecut.",
  futureDateNotAllowed: "Nu puteți programa ședințe după astăzi.",
  futureDateWithinYearNotAllowed: "Nu puteți programa ședințe după un an.",
  pastTimeNotAllowed: "Ora selectată nu poate fi în trecut.",
  pageNotFound: "Pagina nu a fost găsită sau nu aveți acces la ea!",
  search: "Căutare",
  globalSearchPlaceholder:"Caută cursanți după nume, prenume, CNP sau alte date...",
  siteName: "SigurLaVolan",
  delay: "Întârziere",
  logout: "Deconectare",
  documentation: "Documentație",
  defaultManagement: "Gestiune implicită",
  subtotal: "Subtotal",
  confirm: "Confirmare",
  orderOfferWhatsappTemplate: "Șablon WhatsApp pentru comandă/ofertă",
  whatsAppFooterNoteObservation: "",
  pages: "Pagini",
  image: "Imagine",
  newMasculine: "Nou",
  userManual: "Manual de utilizare",
  notifications: "Notificări",
  noNotifications: "Nu există notificări",
  myAccount: "Contul meu",
  legalPerson: "Persoană juridică",
  physicalPerson: "Persoană fizică",
  shouldClientReceiveEmail: "Clientul ar trebui să fie contactat prin email?",
  syncProducts: "Sincronizare produse",
  users: "Utilizatori",
  workPoints: "Puncte de lucru",
  schoolName: "Numele școlii",
  serialNumber: "Număr serial",
  number: "Număr",
  authorizationSeries: "Serie autorizație",
  authorizationNumber: "Număr autorizație",
  administrator: "Administrator",
  director: "Director",
  taxData: "Date fiscale",
  user: "Utilizator",
  CNP: "CNP",
  userSettings: "Setări utilizator",
  sets: "SETURI",
  noConversationsAvailable: "Nu sunt conversații disponibile",
  addNewConversation: "Adaugă conversație nouă",
  conversations: "Conversații WhatsApp",
  newConversation: "Conversație nouă",
  selectAllProductsForInvoice: "Selectează toate produsele pentru facturare",
  departments: "Departamente",
  options: "Opțiuni",
  WARNING: "Avertisment",
  phoneNumbers: "Numere de telefon",
  takePhoto: "Captează fotografia",
  takeAPhoto: "Captează o fotografie",
  photoTaken: "Fotografia a fost capturată",
  availablePhoneNumber: "Număr de telefon disponibil",
  whatsAppEditTemplateLimit:
    " Șabloanele aprobate pot fi editate de până la 10 ori într-o fereastră de 30 de zile sau o dată într-o fereastră de 24 de ore. Dacă ați efectuat deja această acțiune, vă rugăm să reveniți mai târziu.",
  whatsAppTemplateEditingWarning:
    "Doar șabloanele cu statusul APROBAT, RESPINS sau ÎN APROBARE pot fi editate. Puteți edita doar categoria sau componentele unui șablon. Nu puteți edita categoria unui șablon aprobat. Șabloanele aprobate pot fi editate de până la 10 ori într-o fereastră de 30 de zile sau o dată într-o fereastră de 24 de ore. Șabloanele respinse sau în pauză pot fi editate de un număr nelimitat de ori. După editarea unui șablon aprobat sau în aprobare, acesta va fi aprobat automat, cu excepția cazului în care nu trece de revizuirea șablonului.",
  countryCode: "Cod țară",
  phoneNumbersDisplayName: "Numele afișat pentru numărul de telefon",
  lastName: "Nume",
  product: "Produs",
  entityName: "Nume entitate",
  collected: "Încasată",
  collect: "Încasează",
  notCollected: "Neîncasată",
  canceled: "Anulată",
  corrected: "Stornată",
  invoiced: "Facturat",
  previewDocument: "Previzualizare document",
  previewVideo: "Previzualizare video",
  addPhoneNumber: "Adaugă număr de telefon",
  firstName: "Prenume",
  preview: "Previzualizare",
  continue: "Continuă",
  code: "Cod",
  property: "Proprietate",
  create: "Crează",
  upload: "Încarcă",
  learnMore: "Află mai mult",
  pin: "PIN",
  select: "Selectați",
  back: "Înapoi",
  phoneNumbersDisplayNameHelperText:
    "Numele dvs. afișat trebuie să se potrivească cu numele companiei dvs. și să respecte regulile privind numele afișat WhatsApp Business. ",
  twoStepVerificationPinHelperText:
    "Introduceți un cod pentru autentificarea în doi pași atunci când vă conectați utilizând numărul de telefon WhatsApp Business",
  lastStep: "Ultimul pas",
  registerPhoneNumber: "Înregistrare număr de telefon",
  register: "Înregistrare",
  verifyPhoneNumberRegistrationCode:
    "Introducere cod de verificare primit prin SMS",
  setPinForTwoStepVerification: "Setare PIN pentru autentificare în doi pași",
  buttonText: "Text buton",
  orderNr: "Număr comandă",
  thankYouForYourOrder: "Mulțumim! Comanda a fost plasată.",
  ANPC: "ANPC",
  contact: "Contact",
  addNewTemplate: "Adaugă șablon nou",
  cookiePolicy: "Politica Cookies",
  old: "Veche",
  goods: "Marfa",
  password: "Parolă",
  view: "Vizualizează",
  cancelAction: "Anulează",
  billingAction: "Facturează",
  previous: "Anterior",
  next: "Următor",
  crtNo: "Nr. crt.",
  invoice: "Factură",
  notice: "Aviz",
  issuingInvoice: "Emitere factură",
  issuingNotice: "Emitere aviz",
  email: "Email",
  documentEmail: "Email documente",
  addImage: "Adaugă imagine",
  columns: "Coloane",
  phoneNumber: "Număr de telefon",
  roles: "Roluri",
  role: "Rol",
  lei: "Lei",
  advance: "Avans",
  department: "Departament",
  edit: "Editează",
  delete: "Șterge",
  description: "Descriere",
  noResultsFound: "Nu a fost găsit nici un rezultat...",
  nextPage: "Pagina următoare",
  previousPage: "Pagina anterioară",
  rowsPerPage: "Rânduri pe pagină",
  of: "din",
  downloadCSV: "Descarcă CSV",
  print: "Printează",
  uploadImageOnEmailTemplateMessage:
    "Asigurați-vă că ați plasat cursorul unde doriți să plasați imaginea!",
  rowsDeleted: "rânduri șterse",
  rowsSelected: "rânduri selectate",
  usersList: "Listă utilizatori",
  departmentsList: "Listă departamente",
  tasksList: "Listă task-uri",
  projectsList: "Listă proiecte",
  reportsList: "Listă rapoarte",
  deleteFilters: "Șterge filtre",
  tasks: "Task-uri",
  add: "Adaugă",
  import: "Importă",
  project: "Proiect",
  assignedUser: "Responsabil",
  name: "Nume",
  ok: "OK",
  addSubtask: "Adaugă subtask",
  subtask: "Subtask",
  subtasks: "Subtask-uri",
  noUserAssigned: "Nu există utilizator asignat",
  sendMessageTemplateToUser: "Trimite șablon",
  selectAConversation: "Selectează o conversație.",
  canOnlySendTemplateToClient:
    "Șabloanele pot fi trimise doar clienților existenți.",
  youHaveUnreadMessages: "Aveți mesaje necitite.",
  unsavedChangesTitleModal: "Modificări nesalvate",
  unsavedChangesTextModal:
    "Dacă părăsiți pagina, modificările nesalvate vor fi pierdute. Sunteți sigur că doriți să părăsiți pagina?",
  departmentHead: "Șef departament",
  projectManager: "Manager proiect",
  status: "Status",
  flexibleTask: "Task flexibil",
  repeatsOn: "Repetă",
  skipWeekend: "Sari peste weekend",
  flexibleTaskObservations:
    "Permite posibilitatea de modificare a periodicitații",
  progress: "Progres",
  addNewUser: "Adaugă utilizator nou",
  editUser: "Editează utilizator",
  addNewDepartment: "Adaugă departament nou",
  save: "Salvare",
  approve: "Aprobare",
  saveContact: "Salvează contact",
  cancel: "Anulare",
  addFiles: "Adaugă fișiere",
  finish: "Finalizare",
  generate: "Generează",
  finished: "Finalizat",
  unfinished: "Nefinalizat",
  userName: "Nume utilizator",
  taskName: "Nume task",
  active: "Activ",
  inactive: "Inactiv",
  addConversation: "Adaugă conversație",
  archived: "Arhivat",
  cif: "CIF",
  messages: "Mesaje",
  baseInfo: "Informații generale",
  dynamicInfo: "Informații dinamice",
  attachments: "Atașamente",
  issueDate: "Data emiterii",
  dueDate: "Data scadenței",
  otherInfos: "Alte informații",
  issuerName: "Întocmit de",
  issuerId: "CNP",
  deputyIdentityCard: "Carte identitate delegat",
  selesAgent: "Agent vânzări",
  filters: "Filtre",
  invoiceWarning:
    "Pentru a evita erori și neînțelegeri în procesul de facturare, vă rugăm să verificați cu atenție informațiile despre client înainte de a emite o factură. Asigurați-vă că toate datele sunt corecte și actualizate pentru a asigura un proces de facturare fără probleme. ",
  deputyName: "Delegat",
  fancyName: "Denumire",
  startDate: "Data",
  nextContactDate: "Data următoarei contactări",
  nextTransportDate: "Data următoarei livrări",
  endDate: "Data final",
  fullName: "Nume complet",
  position: "Funcție",
  dragAndDrop:
    "Trageți și plasați orice fișier aici sau răsfoiți de pe dispozitiv",
  error: "Eroare!",
  errorWhileProcessingWronging:
    "Eroare la procesarea imaginii. Vă rugăm să încadrați actul cât mai corect posibil.",
  notFound: "Nu a fost găsit.",
  dashboard: "Bord",
  newTask: "Task nou",
  url: "URL",
  supportTickets: "Tichete suport",
  marketing: "Marketing",
  sales: "Vânzări",
  instructors: "Instructori",
  angajati: "Angajați",
  profilePicture: "Poza de profil",
  addCustomField: "Adaugă câmp personalizat",
  customField: "Câmp personalizat",
  custom: "Personalizat",
  specificAction: "Acțiune specifică",
  quickReply: "Răspuns rapid",
  visitSite: "Vizitează site",
  callPhoneNumber: "Sună numărul de telefon",
  value: "Valoare",
  priority: "Prioritate",
  periodicity: "Periodicitate",
  periodic: "Periodic",
  type: "Tip",
  home: "Acasă",
  daily: "Zilnic",
  weekly: "Săptămânal",
  monthly: "Lunar",
  yearly: "Anual",
  choosePeriodicity: "Alege periodicitate",
  biannual: "Semestrial",
  quarterly: "Trimestrial",
  unique: "Unic",
  highPriority: "Înaltă",
  mediumPriority: "Medie",
  lowPriority: "Scăzută",
  chooseUser: "Alege utilizator",
  chooseProject: "Alege proiect",
  choosePriority: "Alege prioritate",
  chooseDepartment: "Alege departament",
  chooseStatus: "Alege status",
  clients: "Clienti",
  onlineClients: "Clienti online",
  client: "Client",
  clientAddress: "Adresa client",
  clientDetails: "Informații client",
  orderDetails: "Detalii comandă",
  phoneNumberDetails: "Detalii număr de telefon",
  order: "Comanda",
  Verified: "Verificat",
  notVerified: "Neverificat",
  postcode: "Cod poștal",
  creationDate: "Data creării",
  lastModified: "Ultima salvare",
  orderProducts: "Produse comandă",
  ordersStatuses: "Status cursanti",
  templates: "Șabloane",

  checkPhoneNumber: "Verificare număr de telefon",
  pagination: {
    next: "Urmator",
    previous: "Anterior",
    rowsPerPage: "Pe pagina:",
    displayRows: "din",
  },
  goToPage: "Mergi la pagina",
  downloadCurrentPage: "Descarcă pagina curentă",
  downloadAllData: "Descarcă toate datele",
  printCurrentPage: "Printează pagina curentă",
  printAllData: "Printează toate datele",
  noData: "Nu exista date!",
  searchResults: "Rezultate căutare",
  orders: "Comenzi",
  reset: "Resetează",
  resetSuccess: "Setările au fost resetate la valorile inițiale",
  statusesOrder: "Ordinea statusurilor",
  reports: "Rapoarte",
  confirmDeleteTitle: "Confirmare ștergere",
  confirmDeleteMessage: "Ești sigur că vrei să ștergi această înregistrare?",

  confirmDuplicateMessage:
    "Ești sigur că vrei să duplici această înregistrare?",
  no: "Nu",
  yes: "Da",
  editModalTitle: "Editează",
  username: "Nume utilizator",
  saveSuccess: "Datele au fost salvate cu succes!",
  saveError: "Eroare la salvarea datelor!",
  editOrderStatus: "Editează status comandă",
  addOrderStatus: "Adaugă status comandă",
  getError: "Eroare la preluarea datelor!",
  deleteSuccess: "Datele au fost șterse cu succes!",
  deleteError: "Eroare la ștergerea datelor!",
  newOrderStatus: "Status comandă nou",
  orderStatus: "Status permis",
  atestatStatus: "Status atestat",
  phone: "Telefon",
  contactPerson: "Persoană de contact",
  address: "Adresă",
  usefulInfo: "Informații utile",
  observations: "Observații",
  noMoreMessages: "Nu mai sunt mesaje",
  sendMessagesInfo:
    "Pentru a comunica eficient prin WhatsApp, este necesar să trimitem mai întâi un template de mesaj aprobat de WhatsApp. Acest mesaj introductiv trebuie să ofere utilizatorului toate detaliile necesare și să solicite un răspuns. După ce utilizatorul răspunde la acest mesaj, putem continua conversația fără restricții, conform regulilor WhatsApp, asigurând astfel o comunicare fluentă și eficientă.",
  fiscalCode: "Cod fiscal",
  tradeRegisterNo: "Nr. Registru Comerț",
  registered: "Înregistrat",
  notRegistered: "Neînregistrat",
  whatsAppRegisterPhoneNumberHelperText:
    "Ultimul pas înainte de a putea comunica prin WhatsApp Business este să înregistrați numărul de telefon. Dacă numărul de telefon verificat are deja activată verificarea în doi pași, introduceți codul PIN de 6 cifre. Dacă numărul de telefon verificat nu are activată verificarea în doi pași, setați un cod PIN de 6 cifre. ",
  details: "Detalii",
  week: "Săptămâna",
  day: "Ziua",
  city: "Oraș",
  county: "Județ",
  tools: "Altele",
  country: "Țară",
  street: "Stradă",
  takenBy: "Preluat de",
  addressDetails: "Detalii adresă",
  category: "Categorie",
  categories: "Categorii",
  hideSets: "ASCUNDE SETURI",
  tags: "Etichete",
  addVariable: "Adaugă variabilă",
  selectATemplateBeforeSendingAnEmail:
    "Selectați un șablon înainte de a trimite un email",
  variable: "Variabilă",
  samplesForBodyContent: "Exemple pentru conținutul variabilelor",
  addButton: "Adaugă buton",
  whatsAppHeaderNoteObservation:
    "Adăugați un titlu sau alegeți ce tip de conținut media veți folosi pentru acest antet.",
  messageswhatsAppFooterNoteObservation:
    "Dacă adăugați mai mult de 3 butoane, acestea vor apărea într-o listă. Numărul maxim de butoane permise este 10.",
  enterWhatsAppMessageFooterText:
    "Adăugați un scurt text în subsolul șablonului de mesaj.",
  enterWhatsAppMessageBodyText:
    "Introduceți textul corpului mesajului WhatsApp în limba selectată.",
  whatsAppFooterButtonsHelperText:
    "Creați butoane care le permit clienților să răspundă la mesajul dumneavoastră sau să execute o acțiune specifică.",
  bank: "Banca",
  iban: "IBAN",
  noDays: "Nr. zile",
  optional: "Opțional",
  required: "Obligatoriu",
  contactPersonName: "Nume persoană contact",
  contactPersonPhoneNumber: "Număr de telefon persoană contact",
  contactPersonEmail: "Email persoană contact",
  categoryName: "Denumire categorie",
  periodicityName: "Nume periodicitate",
  color: "Culoare",
  chooseTemplate: "Alege șablon",
  chooseType: "Alege tip",
  emailContent: "Conținut email",
  exampleContent: "Exemplu conținut",
  price: "Preț",
  pricePerHour: "Preț pe ședință",
  products: "Produse",
  actionSummary: "Sumar acțiune",
  emailContentError: "Conținutul email-ului este obligatoriu",
  pretOnSite: "Preț pe site",
  oblioPrice: "Preț Oblio",
  wordpressSync: "Sincronizare Wordpress",
  billing: "Facturare",
  diferences: "Diferențe",
  SUCCESS: "Succes",
  ERROR: "Eroare",
  INFO: "Informație",
  action: "Acțiune",
  info: "Informație",
  noIdentifier: "Fără identificator",
  identifier: "Identificator",
  initialsValues: "Valori inițiale",
  modifiedValues: "Valori după modificare",
  "email-templates": "Șabloane email",
  "order-statuses": "Status comenzi",
  "transport-options": "Opțiuni transport",
  "tax-classes": "Clase TVA",
  "client-categories": "Categorii clienți",
  whatsapps: "Configurare WhatsApp",
  ignoreOblioIdsList: "Lista de ID-uri Oblio ignorate (separate prin virgulă)",
  nameContactPerson: "Nume persoană contact",
  orderSummary: "Sumar comandă:",
  contactPhoneNumber: "Număr de contact",
  date: "Dată",
  dateWithDiacritics: "Dată",
  total: "Total",
  logs: "Loguri",
  confirmSaveOrUpdateOrder: "Confirmați salvarea sau actualizarea comenzii?",
  orderSettings: "Setări comandă",
  startOrderNumber: "Nr. comandă start",
  currentOrderNumber: "Nr. comandă curent",
  paymentMethods: "Metode de plată",
  emailTemplates: "Șabloane email",
  emailPreview: "Previzualizare email",
  addClient: "Adaugă client nou",
  associateConversationWithClient: "Asociază conversația",
  associateExistingClient: "Asociază client existent",
  addNewClientOrAssociateExisting:
    "Momentan, conversația nu este asociată cu niciun client din aplicație. Dorești să adaugi un client nou, care va fi asociat automat cu această conversație, sau să asociezi unul existent?",
  template: "Șablon",
  subject: "Subiect",
  from: "De la",
  method: "Metodă",
  phoneNumberFormat: "(Format acceptat +40XXXXXXXXX)",
  nrOfAcceptedButtons: "Nr. butoane permise: ",
  whatsappIntegration: "Integrare WhatsApp",
  clientType: "Tip client",
  to: "Către",
  emailTemplate: "Șablon email",
  editor: "Editor",
  emailTemplateName: "Nume șablon email",
  associateClientWithConversation: "Asociază client cu conversație",
  cc: "CC",
  header: "Antet",
  body: "Corp",
  footer: "Subsol",
  buttons: "Butoane",
  productDescription: "Descriere produs",
  loginWithFacebook: "Conectare cu Facebook",
  dimensions: "Dimensiuni",
  length: "Lungime",
  templateName: "Nume șablon",
  templateLanguage: "Limba șablon",
  width: "Lățime",
  remarks: "Observații",
  enterTextInSelectedLanguage: "Introduceți text în limba selectată",
  whatsAppMessagesTemplates: "Șabloane mesaje WhatsApp",
  whatsAppTemplate: "Șablon WhatsApp",
  height: "Înălțime",
  start: "Start",
  end: "Sfârșit",
  days: "Zile",
  lateTask: "Task întârziat",
  finishDate: "Data finalizării",
  productLink: "Link produs",
  whatsAppTemplateBodyContentForHelperText:
    "Pentru a ne ajuta să revizuim șablonul dvs. de mesaj, vă rugăm să adăugați un exemplu pentru fiecare variabilă din corpul dvs. de text. Nu utilizați informații reale despre clienți",
  enterContentFor: "Introduceți conținut pentru",
  enterEmailAddressesSeparatedByComma:
    "Introduceți adresele de e-mail separate prin virgulă",
  addDynamicData: "Adaugă date dinamice",
  additionalData: "Date suplimentare",
  emailTemplateAttachedToOrderStatus: "Atașează la statusul comenzii",
  productName: "Selectează tipul de permis",
  unitMeasure: "Unitate de masură",
  quantity: "Cantitate",
  unitPrice: "Preț unitar fără tva",
  cotaTVA: "Cota TVA",
  tva: "TVA",
  duplicate: "Duplică",
  youNeedToSelectAtLeastOneProductToGenerateInvoice:
    "Trebuie să selectați cel puțin un produs pentru a genera o factură",
  youNeedToSelectAtLeastOneProductToGenerateNotice:
    "Trebuie să selectați cel puțin un produs pentru a genera un aviz",
  nr: "Nr.",
  discount: "Discount",
  totalDiscount: "Total discount",
  totalDiscountWithouTVA: "Total discount fără TVA",
  totalWithoutTVA: "Total fără TVA",
  otherCosts: "Alte costuri",
  addProducts: "Adaugă produs",
  collectDocType: "Tip document încasare",
  subTotal: "Sub-total",
  valueWithoutTVA: "Valoare fără TVA",
  priveWithTVA: "Preț unitar cu TVA",
  priceWithoutTVA: "Preț fără TVA",
  shippingInfo: "Informații transport",
  sameAsBilling: "Adresa din datele de facturare",
  newShipping: "Adresa de livrare noua",
  cash: "Numerar la livrare",
  delivery: "Livrare",
  backTransfer: "Transfer bancar",
  orderHasntBeenGenerated: "Comanda nu a fost generata",
  card: "Card online",
  vatRate: "Cota TVA",
  subtotalWithTVA: "Subtotal cu TVA",
  subtotal_tax: "Valoare",
  clientContactedOverEmail: "Contactat prin email:",
  clientCalled: "Contactat telefonic:",
  clientMessaged: "Contactat prin mesaj:",
  takeCustomer: "Preia client",
  totalWithTVA: "Total cu TVA",
  totalTVAIncluded: "Total TVA inclus",
  showTVA: "Afișeaza TVA",
  service: "Serviciu",
  never: "Niciodată",
  courierShipping: "Transport curier",
  stock: "Stoc",
  newOrder: "Comandă nouă",
  close: "Închide",
  noTodaysClients: "Clienți de contactat astăzi",
  clientsToContact: "Clienți de contactat",
  clientsContacted: "Clienți  contactati",
  availableClients: "Clienți zilnici disponibili",
  takenClients: "Clienți zilnici preluati",
  delayedClients: "Clienți disponibili (întârziați)",
  new: "Nouă",
  cifIsRequired: "CIF-ul este obligatoriu",
  clientNameIsRequired: "Numele clientului este obligatoriu",
  seriesNameIsRequired: "Numele seriei este obligatoriu",
  productNameIsRequired: "Numele produsului este obligatoriu",
  productPriceIsRequired: "Prețul produsului este obligatoriu",
  productQuantityIsRequired: "Cantitatea produsului este obligatorie",
  issuerNameIsRequired: "Numele emitentului este obligatoriu",
  issuerIdIsRequired: "CNP-ul emitentului este obligatoriu",
  mentions: "Mentiuni",
  noticeNumber: "Nr. aviz însoțire",
  defaultInvoiceMentions:
    "Factura valabila fără semnatura si ătampila cf. art. V, ALIN(2) DIN ORD. NR. 17/2015 SI ART. 319 ALIN.(29) DIN LEGEA NR. 227/2015 PRIVIND CODUL FISCAL .Cumparatorul isi exprima acordul privind prelucrarea datelor cu caracter personal, comunicate, date ce vor fi utilizate in scopul intocmirii documentelor comerciale de facturare, incasare, expediere si ofertarii comerciale. Orice modificare de preț va fi afisata pe site-ul www.ECOPACKBUSINESS.ro",
  invoicesInfo: "Informații facturare",
  discountValue: "Valoare discount",
  shortDescription: "Descriere scurta",
  unitTVA: "Valoare unitara TVA",
  confirmDelete: "Confirma stergerea",
  settings: "Setari",
  managements: "Gestiuni",
  management: "Gestiune",
  otherSettings: "Alte setari",
  saveWhatsAppSettings: "Salvează setările WhatsApp",
  shippingSettings: "Setări transport",
  whatsAppBusinessAccountId: "Id cont WhatsApp Business",
  whatsAppBusinessAccountName: "Nume cont  WhatsApp Business",
  whatsAppBusinessPhoneNumberId: "Id număr de telefon WhatsApp Business",
  whatsAppBusinessVerifiedName: "Nume WhatsApp Business",
  whatsAppBusinessAccountDataUpdateMessage:
    "Sunteți sigur că doriți să actualizați datele contului WhatsApp Business?",
  oblio: "Oblio",
  conversationOptions: "Opțiuni conversație",
  LOCAL: "Local",
  WORDPRESS: "WordPress",
  OBLIO: "Oblio",
  META: "META",
  whatsApp: "WhatsApp",
  contactDate: "Data contactării",
  shipping: "Transport",
  clientCategory: "Categorie client",
  clientNotesHistory: "Istoric note client",
  welcomeBack: "Bine ai revenit,",
  sendMessage: "Trimite mesaj",
  sendEmail: "Trimite email",
  createOrder: "Creează comandă",
  summary: "Sumar",
  visibleToClient: "Vizibil clientului",
  finishContact: "Finalizează contact",
  contactedOnPhone: "Telefonic",
  clientCategories: "Categorii clienti",
  wasClientCalledOverPhone: "Clientul a fost contactat telefonic?",
  contacted: "Contactat",
  noOrder: "Fără comandă",
  notContacted: "Necontactat",
  shouldSendEmailToAllClients:
    "Activează/dezactivează trimiterea automată de emailuri pentru toți clienții.",
  addNotes: "Adaugă note",
  text: "Text",
  reply: "Răspunde",
  templatePreview: "Previzualizare șablon",
  note: "Nota",
  doYouWantToTakeOverThisClient: "Doriți să preluați acest client?",
  transportName: "Nume transport",
  transportValue: "Valoare transport",
  isDefaultTransport: "Transport implicit",
  addMethod: "Adaugă metodă",
  paymentMethod: "Metodă de plată",
  loadMoreMessages: "Incarca mai multe mesaje",
  noPreviewAvailable: "Previzualizare indisponibilă",
  noMessagesYet:
    "Nu există mesaje.\n Pentru a iniția o conversație, trimiteți un sablon. \n\n Dacă clientul va raspunde în 24 de ore veți putea trimite mesaje nelimitate.",
  romania: "România",
  send: "Trimite",
  document: "Document",
  addCaption: "Adaugă descriere",
  missingFile: "Fișier lipsă",
  chooseColor: "Alege culoare",
  orderConfirmMessage: "Vă mulțumim pentru comanda dumneavoastră!",
  chooseNextContactDate: "Alege data urmatoarei contactări:",
  loading: "Se încarca...",
  loadingOverlay: "Se încarcă datele, vă rugăm nu închideți pagina...",
  noMoreItems: "Nu mai sunt elemente!",
  shippingCost: "Cost transport (TVA inclus)",
  currency: "LEI",
  unsavedMessage: "Ai modificari nesalvate!",
  clientConversation: "Conversatie client",
  database: "Baza de date",
  transportMethods: "Metode transport",
  confirmMessage: "Parolele nu coincid!",
  phoneValidation: "Numarul de telefon este invalid",
  ibanValidation: "IBAN-ul nu este valid",
  finishOrder: "Finalizare comanda",
  clientNote: "Nota adăugată de client",
  optionalOrderNote: "Note comandă (opțional)",
  invalidEmail: "Email invalid",
  contacts: "Contacte",
  threshold: "Valoare de prag (limită)",
  rule: "Regulă",
  agent: "Agent",
  sendNotificationsTo: "Trimite notificări către",
  imagePreview: "Previzualizare imagine",
  contactDeletionThreshold:
    "Numărul de zile după care contactele vechi sunt șterse automat",
  data: "Data",
  shouldRenderOldContactsOnDashboard: "Afișează contactele vechi pe Dashboard.",
  orderMessage:
    "Pentru comenzile ce depasesc 5KG se taxeaza în plus 1 LEU / KG.",
  pressTocChangeStatus: "Apasă pentru a adaugă/schimbă statusul comenzii",
  invoiceDetails: "Detalii de facturare",
  anotherAddress: "Livrezi la o altă adresă?",
  yourOrder: "Comanda ta",
  addNewSubtask: "Adaugă subtask nou",
  imageAlternativeText: "Text alternativ imagine",
  confirmPassword: "Confirmare parola",
  passwordsMustMatch: "Parolele trebuie să fie identice",
  newPassword: "Parolă nouă",
  leaveEmptyToKeepCurrent: "Lasă gol pentru a păstra parola actuală",
  deleteImages: "Șterge imagini",
  outOfStock: "Stoc epuizat",
  assignedBy: "Alocate de",
  editSubtask: "Editează subtask",
  attachedFiles: "Fișiere atașate",
  emptyFields: "Golește câmpurile",
  inStock: "În stoc",
  duplicateTask: "Duplică task",
  task: "Task",
  alerts: "Alerte",
  alert: "Alertă",
  onBackOrder: "Pe comandă",
  customFilter: "Filtru personalizat",
  table: "Tabel",
  noStockInfo: "Fără informații despre stoc",
  endOrder: "Plasează comanda",
  footerText:
    "Avem la comercializare o gama variata de pungi de hartie, atat albita, cat si natur, dar si sacose de hartie cu maner flat sau sfoara.",
  copyright: "© Sigur la volan Business 2025",
  imageUploadErrorMessage:
    "Trebuie să incărcați o imagine și să oferiți o alternativă de text pentru aceasta!",
  /**AUDIT ACTIONS */
  CREATE: "Adăugare",
  UPDATE: "Actualizare",
  DELETE: "Ștergere",
  SOFT_DELETE: "Inactivare",
  IMPORT: "Import",
  DUPLICATE: "Duplicare",
  /**ERRORS */
  systemError: "Eroare de sistem. Contactează administratorul!",
  getDataError: "Eroare la preluarea datelor!",
  deleteDataError: "Eroare la ștergerea datelor!",
  importDataError: "Eroare la importul datelor!",
  createDataError: "Eroare la adăugarea datelor!",
  updateDataError: "Eroare la actualizarea datelor!",
  deleteDataSuccess: "Datele au fost șterse cu succes!",
  importDataSuccess: "Datele au fost importate cu succes!",
  createDataSuccess: "Datele au fost adăugate cu succes!",
  updateDataSuccess: "Datele au fost actualizate cu succes!",
  chooseStatusColor: "Alegeți o culoare pentru status.",
  createdAt: "Dată creare",
  isActive: "Este activ",
  open: "Deschis",
  closed: "Inchis",
  CUI: "CUI",
  vehicles: "Vehicule",
  brand: "Marcă",
  model: "Model",
  vehicleNumber: "Nr. de înmatriculare",
  modelDate: "An fabricație",
  addDocument: "Adaugă document",
  addRevizie: "Adaugă revizie",
  workPoint: "Sediu",
  services: "Servicii",
  isCertificate: "Este certificat",
  automata: "Automată",
  vehicle: "Maşină",
  instructor: "Instructor",
  instructorAndVehicle: "Instructor şi Vehicul",
  sumaPlatita: "Suma plătită",
  platit: "Plătit",
  pret: "Pret",
  clientName: "Nume client",
  chassis: "Serie de şasiu",
  cursanti: "Cursanți",
  vehicleNumberFormat:
    "Format invalid! Introdu un cod de forma SV-25-XYZ (2 litere mari, 2 cifre, 3 litere mari).",
  activate: "Activează",
  deactivate: "Dezactivează",
  confirmActivateVehicle: "Ești sigur că vrei să activezi acest vehicul?",
  confirmDeactivateVehicle: "Ești sigur că vrei să dezactivezi acest vehicul?",
  documentName: "Nume document",
  documentDate: "Dată document",
  expirationDocumentDate: "Dată expirare document",
  documentType: "Tip document",
  documentTypeName: "Nume tip document",
  additionalNotes: "Note suplimentare",
  documentValidity: "Valabilitate Acte",
  personalDocuments: "Acte Personale",
  vehicleDocuments: "Acte Mașini",
  invalidVINFormat:
    "Formatul VIN-ului este invalid. Asigurați-vă că VIN-ul are 17 caractere.",
  orderStatusType: "Tipul statusului",
  orderStatusTypeIsRequired: "Tipul statusului este obligatoriu",
  recomended: "Recomandare",
  recomendedBy: "Recomandat de",
  person: "Persoană",
  generalInformation: "Informații Client",
  instructorsPayment: "Plăți instructori",
  reward: "Recompensă",
  completedHours: "Ore efectuate",
  clientPayments: "Listă încasări plăți",
  examList: "Listă examene",
  booksList: "Listă cărți",
  id: "ID",
  account: "Cont",
  payment: "Plată",
  paymentComment: "Mențiuni plată",
  allPaymentsMadeToInstructor:
    "Lista tuturor plăților efectuate către instructori",
  orderCreatedAt: "Dată înscriere",
  editClient: "Actualizare informații client",
  class: "Grupă",
  classes: "Grupe",
  amountReceived: "Suma încasată",
  totalAmount: "Suma totală",
  remainingAmount: "Suma restantă cursant",
  amountPaidToInstructor: "Suma plătită către instructor",
  registerClient: " Înregistrează cursant",
  selectProduct: "Selectează Produs",
  scanID: "Scaneaza Buletinul",
  scanDriverLicense: "Scaneaza Permisul de Conducere",
  scanIdCard: "Scaneaza Cartea de Identitate",
  cnpRecommended: "CNP Persoana care recomandă",
  cnpClient: "CNP Cursant",
  saveClient: "Salvează Clientul",
  invalidCNP: "CNP invalid. Trebuie să conțină 13 cifre.",
  invalidCNPFull: "CNP invalid.",
  psychologicalDate: "Dată psihologic",
  medicalDate: "Dată medical",
  criminalRecordDate: "Dată cazier",
  suplimentaryHours: "Adăugare ore efectuate",
  startHour: "Ora început",
  endHour: "Ora sfârșit",
  addHours: "Adaugă Ore Efectuate",
  addSupplementeryHours: "Adaugă Ședințe Suplimentare",
  addMedicalExamHour: "Adaugă dată  medical",
  addPsychologicalExamHour: "Adaugă dată psihologic",
  addCriminalRecordHour: "Adaugă dată cazier",
  changeStatus: "Ești sigur că vrei să schimbi statusul?",
  newStatus: "Status nou:",
  addVehicle: "Schimbă maşină",
  selectVehicle: "Selectare maşină",
  addInstructor: "Schimbă instructor",
  selectInstructor: "Selectare instructor",
  employee: "Funcționar",
  addNewClass: "Adaugă grupă nouă",
  selectClass: "Selectare grupă",
  selectClassType: "Selectare tip grupă",
  nrOfClientsGraduates: "Număr cursanți  absolviți",
  nrOfClients: "Număr cursanți totali",
  collectPayment: "Încasează plata",
  addNewProductToClient: "Adaugă un produs nou la cursant",
  startKm: "Km de început",
  endKm: "Km de sfârșit",
  hoursDescription: "Lista tuturor ședințelor realizate deja",
  sessions: "ședințe",
  endKmValidation:
    "Kilometrajul final trebuie să fie mai mare sau egal cu cel de început.",
  clientHistory: "Arhivă client",
  editPrice: "Edit preț",
  pay: "Plată",
  payemntNote: "Mențuni plată",
  nrOfSupplimentaryHours: "Numărul de ședințe suplimentare",
  totalDrivingHours: "Total ședințe",
  drivingHours: "Ședințe efectuate",
  hoursPerformed: "Ore efectuate",
  practicalExamDate: "Examen practic",
  theoreticalExamDate: "Examen teoretic",
  theoreticalPassRate: "Promovabilitate teoretic",
  practicalPassRate: "Promovabilitate practic",
  practical: "Practic",
  theoretical: "Teoretic",
  scheduleTheoreticalExam: "Programare exam teoretic",
  scheduledTheoreticalExams: "Examene Teoretice Programate",
  scheduledPracticalExams: "Examene Practice Programate",
  addMessageToTeam: "Salvează un mesaj pentru echipă",
  ARRNr: "Nr. ARR",
  arrAdmissionDate: "Data admiterii ARR",
  referrals: "Recomandări",
  editArrNumber: "Schimbă ARR",
  addArrNumber: "Adaugă ARR",
  workId: "ID Lucrare",
  examDate: "Data examinării",
  passedExamOnFirstAttempt: "A promovat din prima examenul?",
  passedTheoreticalExamOnFirstAttempt: "A promovat din prima examenul teoretic?",
  passedPracticalExamOnFirstAttempt: "A promovat din prima examenul practic?",
  admitted: "Admis",
  rejected: "Respins",
  certificateExams: "Examene pentru certificate",
  examType: "Tip examen",
  retryExam: " Reia data examinării",
  productType: "Tipul de produs",
  cashDesk: "Caserie",
  income: "Incasare",
  payments: "Plăți",
  salaries: "Salarii",
  transfer: "Transfer",
  systemSettings: "Setări sistem",
  general: "General",
  accounts: "Conturi",
  companies: "Firme",
  subscription: "Abonament",
  subscriptions: "Abonamente",
  subscriptionPlan: "Plan Abonament",
  subscriptionDetails: "Detalii Abonament",
  subscriptionBenefits: "Beneficii Abonament",
  benefits: "Beneficii",
  duration: "Durată",
  multipleIntervals: "Intervale multiple",
  numberOfSessions: "Număr ședințe",
  sessionDuration: "Durată ședință",
  minutes: "minute",
  icon: "Pictogramă",
  addBenefit: "Adaugă beneficiu",
  removeBenefit: "Șterge beneficiu",
  examsCalendar: "Calendar Examene",
  accountsList: "Lista tuturor firmelor",
  addAccount: "Adaugă cont nou",
  editAccount: "Editează cont",
  paymentType: "Normal sau returnare bani",
  paymentDescription: "Detalii privind plata ..",
  amount: "Plata",
  totalIncome: "Total încasări",
  totalPayments: "Total plăți",
  balance: "Balanță",
  cursant: "Cursant",
  refund: "Returnare",
  moneyWithdraw: "Retragere bani din cont",
  amountWithdraw: "Suma de retragere",
  reportsInstructorClients: "Rapoarte instructori cursanti",
  reportsOrderStatuses: "Rapoarte pe stări",
  reportsWorkPoints: "Rapoarte pe sedii",
  reportsCompany: "Rapoarte pe firme",
  company: "Companie",
  selectCompany: "Selectează companie",
  reportsClients: "Rapoarte pe clienti",
  reportsUserSalary: "Rapoarte pe salarii",
  reportsUserActions: "Rapoarte pe fiecare functionar",
  reportsInstructorTimesheet: "Raport pontaj instructor",
  reportsDrivingHours: "Rapoarte pontaj pe zile instructor",
  reportsClientsInstructors: "Raport cursanti/instructor",
  reportsClientPayments: "Rapoarte încasări de la cursanți pe instructori",
  payed: "Achitat",
  restToPay: "Restant",
  payedToInstructor: "Plata instructor",
  defaultDrivingHours: "Numarul de sedințe implicite",
  supplementaryHours: "Ore suplimentare",
  supplementaryHourPrice: "Preț oră suplimentară",
  totalPaidToUser: "Total plătit către instructor/funcționar",
  totalIncomeFromUser: "Total încasări din cursanți",
  distance: "Distanță",
  scheduledExams: "Examene Programate",
  programedDate: "Data programării",
  reminderPsychologicalExpiration: "Alertă psihologic cursant",
  reminderCategoryExpiration: "Alertă categorii cursant",
  monitorProduct: "Prag de monitorizare (luni rămase)",
  nrOfRemainingMonths: "Nr. luni",
  expireIn: "Expirã în",
  isExpired: "Expirat",
  reminderCarDocuments: "Avertizare expirare documente mașini",
  reminderUserDocuments: "Avertizare expirare documente utilizatori",
  ITP: "ITP",
  RCA: "RCA",
  Insurance: "Asigurare",
  months: "luni",
  psychological: "Psihologic",
  medical: "Medical",
  criminal: "Cazier",
  documents: "Documente",
  addExamHours: "Adaugă ore examen",
  examHours: "Ore examen",
  clientCourses: "Legislatii clienți",
  courses: "Cursuri",
  modules: "Module",
  addCourse: "Adaugă un curs",
  sortNumber: "Numărul de sortare",
  mainImage: "Imaginea principală ",
  isMain: "Sediu principal",
  centerImage: "Centrează imaginea în chenar",
  fitYourImageInSquare: "Centrează imaginea în chenar",
  fitYourDriverLicenseFrontInSquare: "Scanează FAȚA permisului",
  fitYourDriverLicenseBackInSquare: "Scanează SPATELE permisului",
  frontSideProcessedSuccessfully:
    "Fața permisului a fost procesată cu succes. Vă rugăm să scanați spatele.",
  idFrontSideProcessedSuccessfully:
    "Fața cărții de identitate a fost procesată cu succes. Vă rugăm să scanați spatele.",
  fitYourIdFrontInSquare: "Captează fața cărții de identitate",
  fitYourIdBackInSquare: "Captează spatele cărții de identitate",
  newIdCardModel: "Model nou de carte de identitate",
  imageProcessedSuccessfully: "Imaginea a fost prelucrată cu succes",
  imageProcessingFailed:
    "Imaginea nu a fost prelucrată cu succes, plaseasa imaginea în regim portret",
  course: "Curs",
  content: "Conținut",
  videoCourse: "Curs video",
  video: "Video",
  addVideo: "Adaugă video",
  generateUserAccount: "Generează cont utilizator",
  clientAlreadyHasUserAccount: "Cursantul are deja un cont de utilizator",
  examSet: "Seturi întrebări examen",
  addExamSet: "Adaugă set întrebări examen",
  examQuestions: "Întrebări Examen",
  tokenOCR: "Token OCR",
  tokenOCRDescription: "Token pentru OCR folosit pentru extragerea datelor",
  addToken: "Adauga token",
  question: "Întrebare",
  answers: "Răspunsuri",
  addAnswer: "Adaugă răspuns",
  correct: "Corect",
  examCategory: "Categorie examen",
  questionsInExam: "Nr de întrebări din examen",
  imageIsProcessing: "Se procesează...",
  process: "Procesare",
  alreadyProcessed: "Procesat",
  pleaseWaitProcessingYourPhoto:
    "Vă rugăm să așteptați, procesăm fotografia...",
  changeCamera: "Rotește camera",
  cameraPermissionDenied: "Accesul la cameră a fost refuzat. Verificați permisiunile browserului.",
  cameraNotFound: "Camera nu a fost găsită pe acest dispozitiv.",
  photoInstructions:
    "Poziționează-ți actul de identitate în cadru și atinge Captură",
  uploadPhoto: "Încarcă o poză",
  cameraPhoto: "Fotografie din camera",
  isAutomata: "Schimbare la Cutie automată",
  changeToAutomataConfirmationText: "Confirmare schimbare categorie",
  changeToAutomataText:
    "Urmează să schimbi serviciul în Categoria automată. Această modificare va actualiza datele aferente solicitării și poate afecta opțiunile disponibile pentru candidat. Te rugăm să confirmi că dorești să continui această acțiune.",
  automaticCategoryPriceIncrease: "Majorare preț pentru categoria automată",
  clientReadinessProgress: "Progres pregătire chestionare",
  viewStatistics: "VIZUALIZEAZĂ STATISTICI",
  hideStatistics: "ASCUNDE STATISTICI",
  books: "Cărți",
  addBook: "Adaugă o nouă carte",
  book: "Carte",
  maxPerStudent: "Numărul maxim de cărți per student",
  pieces: "Bucăți",
  alertThreshold: "Prag de alertă",
  sellBookFormTitle: "Înregistrare Produse Cumpărate",
  purchasedAt: "Data cumpărării",
  scheduleDrivingHours: "Programare ședințe de conducere",
  nextWeek: "Săptămâna următoare",
  previousWeek: "Săptămâna anterioară",
  today: "Azi",
  documentTemplates: "Sabloane documente",
  studentNotebook: "Caietul cursantului",
  examinationRequest: "Cerere de examinare",
  taxiAttendenceCertificate: "Adeverință TAXI-PLESA",
  borrowCertificate: "Adeverință Conducători Auto - Închiriere",
  schoolingForm: "Fișă de școlarizare",
  graduationCertificate: "Certificat de absolvire",
  download: "Descarcă",
  generateDocument: "Generează document",
  generating: "Se generează...",
  documentGenerated: "Documentul a fost generat cu succes!",
  documentGenerationError: "Eroare la generarea documentului!",
  missingDataError: "Lipsesc datele necesare pentru generarea documentului!",
  studentNotebookDescription:
    "Generează caietul cursantului cu toate informațiile necesare",
  examinationRequestDescription:
    "Generează cererea de examinare pentru cursant",
  schoolingFormDescription:
    "Generează fișa de școlarizare cu datele cursantului",
  graduationCertificateDescription: "Generează certificatul de absolvire",
  documentTemplateCreated: "Șablonul documentului a fost creat cu succes!",
  documentTemplateUpdated: "Șablonul documentului a fost actualizat cu succes!",
  forbiddenResource:
    "Ne pare rău, nu aveți permisiunea de a accesa această resursă.",
  editHours: "Editează ședințe",
  registerOnline: "Înscriere online",
  visibleForOnlineEnrollment: "Vizibil pentru înscriere online",
  chatData: "Date chat",
  chatSettings: "Setari chat",
  companyChatInformation: "Informații despre companie utilizate pentru chat",
  addChatDescription: "Adauga descriere in chat",
  placeYourIdInRectangle:
    "Poziționează-ți actul de identitate în cadru și atinge captează",
  legalInformation: "Informații legale",
  legalInfoDescription: "Informații legale despre companie",
  addLegalInfo: "Adaugă informații legale",
  drivingRules: "Reguli de conducere",
  drivingRulesDescription: "Regulile de circulație actuale aplicabile",
  addDrivingRules: "Adaugă reguli de conducere",
  examQuestionsDescription: "Întrebări și răspunsuri pentru examenul teoretic",
  addExamQuestions: "Adaugă întrebări de examen",
  uploadFile: "Încarcă fișier",
  drivingRulesAndExam: "Reguli de conducere",
  month: "Lună",
  year: "An",
  current: "Curent",
  history: "Istoric",
  selectYearToFilterExams: "Selectează anul pentru a filtra examenele",
  scheduledExam: "Examen programat",
  all: "Toate",
  exam: "Examen",
  confirmDeleteExam: "Confirmare ștergere examen",
  confirmDeleteExamMessage:
    "Ești sigur că vrei să ștergi acest examen? Această acțiune nu poate fi anulată.",
  examDetails: "Detalii examen",
  bulkWarning:
    "Atenție: această acțiune va schimba statusul tuturor cursanților selectați.",
  addExam: "Adaugă examen",
  comments: "Comentarii",
  processOrder: "Marchează ca procesată si mută în bord",
  chooseCategory:
    "Completează doar unul dintre câmpuri: pentru școala de șoferi selectează categoria de examen, pentru atestate alege produsul din listă.",
  allRequiredDocumentsComplete:
    "Toate documentele obligatorii pentru serviciul curent au fost încărcate.",
  missingRequiredDocuments: "Lipsesc {value} documente obligatorii",
  finalizatBlockedUnpaid:
    "Nu se poate finaliza: există o sumă restantă de {value} lei.",
  finalizatBlockedMissingDocuments:
    "Nu se poate finaliza: lipsesc {value} documente obligatorii.",
  manageTypes: "Gestiune tipuri",
  addNewDocumentType: "Adaugă tip document nou",
  cannotDeleteDocumentTypeWithSlug:
    "Nu poate fi șters - tipul are slug definit",
  cannotDeleteApprovedHour: "Nu poate fi ștearsă o ședință aprobată",
  confirmed: "Confirmat",
  available: "Disponibil",
  needsApproval: "Necesită aprobare",
  decline: "Refuză",
  createdBy: "Creat de",
  canScheduleHours: "Poate programa ședințe de conducere",
  minimOneBenefit: "Trebuie să adaugi cel puțin un beneficiu",
  addInArr: "Adaugă în ARR",
  sendNotification: "Trimite notificare",
  sendSMS: "Trimite SMS",
  fromDate: "De la",
  toDate: "Până la",
  smsClientsTitle: "SMS clienți",
  smsClientsMenu: "SMS clienți",
  showClients: "Afișează",
  smsMessagePlaceholder: "Introduceți mesajul SMS...",
  reportsSmsReport: "Rapoarte SMS trimise",
  message: "Mesaj",
  sentBy: "Trimis de",
  intendedFor: "Destinat pentru",
  smsSent: "Trimis",
  smsError: "Eșuat",
  errorMessage: "Mesaj eroare",
  sendNotificationsAllRoles:
    "Notificările vor fi trimise tuturor utilizatorilor din rolurile selectate",
  sendNotificationsUsers:
    "Notificările vor fi trimise către {count} utilizator(i)",
  notification: "Notificare",
  userRole: "User",
  rest: "Rest",
  previousBalance: "Sold casă",
  amountExceedsRemaining: "Suma introdusă depășește suma restantă de plată.",
  cycleCameras:"Schimbă camera",
  onlineLessons: "Programare ore online",
  onlineLessonTitle: "Titlu lecție",
  onlineLessonScheduledAt: "Dată și oră",
  onlineLessonInstructor: "Instructor",
  joinOnlineLesson: "Intră în lecție",
  noOnlineLessons: "Nu există lecții online.",
  addOnlineLesson: "Adaugă lecție online",
  onlineLessonsPage: "Programare ore online",
  onlineLessonTargetScope: "Audiență",
  onlineLessonScopeSpecific: "Produse selectate",
  onlineLessonScopeAllPermise: "Toți cursanții permise",
  onlineLessonScopeAllAtestate: "Toți cursanții atestate",
  onlineLessonScopeAll: "Toți cursanții",
  onlineLessonRepeatInterval: "Interval repetiție (zile)",
  onlineLessonRepetitions: "Număr de repetări",
  onlineLessonCreatedCount: "ședințe create",
  onlineLessonRepeat: "Lecție repetitivă",
  reportsPassRate: "Raport promovabilitate",
  clientWorkPoint: "Sediu Cursant",
  messagesPerWorkPoint: "Mesaje per punct de lucru",
  smsMessage: "SMS",
  emailMessage: "Email",
  uploadExamScheduleFile: "Încarcă fișierul cu programările la examen",
  verifyClients: "Verifică cursanții",
  sendMessageWithTime: "Trimite mesajul cu ora",
  addNewStudent: "Adaugă cursant nou",
  searchStudent: "Caută un cursant",
  examClientsReview: "Clienți programați la examen",
  examReviewHint: "Verificați lista, modificați ora sau eliminați clienți înainte de a trimite SMS-ul.",
  hour: "Ora",
  newVersionAvailable: "O nouă versiune este disponibilă!",
  reload: "Reîncarcă",
};

/**
 * Replace placeholders in vocabulary strings with actual values
 * @param template - The vocabulary string with {placeholder} markers
 * @param values - Object with placeholder names as keys and replacement values
 * @example replacePlaceholders(Vocabulary.missingRequiredDocuments, { count: 5 }) => "Lipsesc 5 documente obligatorii"
 */
export const replacePlaceholders = (
  template: string,
  values: Record<string, any>
): string => {
  return template.replace(
    /\{(\w+)\}/g,
    (_, key) => values[key]?.toString() ?? ""
  );
};
